// extracted by mini-css-extract-plugin
export var youtube = "style-module--youtube--20922";
export var youtubeBlog = "style-module--youtube--blog--7d89d";
export var youtube__cover = "style-module--youtube__cover--c3414";
export var youtube__cover__button = "style-module--youtube__cover__button--838d2";
export var youtube__placeholder = "style-module--youtube__placeholder--f2b88";
export var youtube__placeholder__img = "style-module--youtube__placeholder__img--0dcdd";